import { createContext } from "react";
import { Context as BizContext } from "./biz/Context";

export const ToolContext = createContext()

export const ToolProvider = ({children, platform}) => {
    let states = {
        business:{...BizContext()},
    }

    return (
        <ToolContext.Provider value={{...states[platform]}}>
            {children}
        </ToolContext.Provider>
    )
}